enum Environment {
  DEV = 'dev',
  STAGING = 'staging',
  UAT = 'uat',
  PROD = 'production',
}

export default Environment;
